<section class="banner">
  <!-- <div #air id="air" class='air'></div> -->
  <app-nav class="w-100"></app-nav>
  <h1 class="col-12 text-center loginBox sstarabic sstarabicbold m-top-12" [style]="'color :white'">
    {{ "Knowledge Library" | translator }}
  </h1>
  <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: -25px;
      flex-direction: column;
    ">
    <hr width="15% col-12" style="color: white; align-self: center" />
    <button class="v4-btn-every" routerLink="/knowledge-library">
      <span class="d-flex badgechane">
        <i class="fa fa-chevron-circle-right prefix" aria-hidden="true"></i>
        <span class="mb-2">{{ "Back" | translator }}</span>
      </span>
    </button>
  </div>
</section>
<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<div class="container mb-2 mt-2">
  <div class="row">
    <div class="col-12 p-2">
      <button *ngIf="hasPermission('c')" (click)="openCreateModal()"
        class="w-100 d-flex justify-content-center v4-btn-every">
        {{ "A new addition" | translator
        }}<img class="plus-icon" src="../../assets/icons/Add/24@1.5x.svg" alt="loading..." />
      </button>
    </div>
  </div>

  <hr />

  <div class="row">
    <div class="col-12 col-md-6 p-2">
      <p-dropdown [options]="availableCategories" styleClass="w-100 h-100" optionLabel="label"
        (ngModelChange)="handleFilter('CATEGORY_FILTER', $event)" [(ngModel)]="category"
        placeholder="{{ 'Category' | translator }}"></p-dropdown>
    </div>
    <div class="col-12 col-md-6 p-2">
      <p-dropdown styleClass="w-100 h-100" [(ngModel)]="selectedOU" appendTo="body" optionLabel="name"
        (ngModelChange)="handleFilter('OU_FILTER', selectedOU)" [options]="availableOus"
        placeholder="{{ 'Choose an organizational unit' | translator }}" [filter]="true">
        <ng-template let-node pTemplate="default">
          <div class="d-flex">
            <img *ngIf="checkisImg(node.image); else elseBlock" src="{{ staticURL }}{{ node.image }}"
              class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
            <ng-template #elseBlock>
              <i class="{{ node.image }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            <b class="text-nowrap">{{ node.name }}</b>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 p-2">
      <p-calendar dir="ltr" class="v4-calander" (ngModelChange)="handleFilter('DATE_FROM_FILTER', $event)"
        styleClass="w-100 h-100" [(ngModel)]="fromDate" [showIcon]="true"
        placeholder="{{ 'starting date' | translator }}"></p-calendar>
    </div>

    <div class="col-12 col-md-6 p-2">
      <p-calendar dir="ltr" class="v4-calander" (ngModelChange)="handleFilter('DATE_TO_FILTER', $event)"
        [minDate]="fromDate" styleClass="w-100 h-100" [(ngModel)]="toDate" [showIcon]="true"
        placeholder="{{ 'Expiry date' | translator }}"></p-calendar>
    </div>

    <div class="col-12 col-md-12 d-flex justify-content-end p-2">
      <button class="v4-btn-every" (click)="reset()">
        {{ "Reset" | translator }}<i class="pi pi-rotate-right v4-ml-2"></i>
      </button>
    </div>
  </div>

  <hr />

  <app-skelitions [hidden]="!preloader" [value]="2"></app-skelitions>
  <app-no-data *ngIf="!preloader && data.length == 0"></app-no-data>
  <app-table [unit]="'KNOWLEDGE_LIBRARY'" *ngIf="!preloader && data.length > 0" [data]="data"
    (actionCall)="actionCall($event)"></app-table>
  <div class="row" *ngIf="!preloader">
    <div class="col py-3" *ngIf="permissionService.hasPermission('KNOWLEDGE_LIBRARY_CATEGORY', 'r')">
      <button routerLink="/dashboard/knowledge-library/category" class="w-100 v4-btn-every-border py-2">
        <i class="pi pi-sitemap v4-ml-2"></i>{{ "Classification modification" | translator }}
      </button>
    </div>
    <div class="col py-3" *ngIf="data.length > 0">
      <button (click)="downloadData()" class="w-100 v4-btn-every py-2">
        <i class="pi pi-download v4-ml-2"></i>{{ "Download data" | translator }}
      </button>
    </div>
  </div>
</div>

<!-- Create Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openModal" [style]="{ width: '80vw' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "A new addition" | translator }}</span>
  </ng-template>
  <app-dynamic-form *ngIf="questions.length > 0 || updateQuestion.length > 0" (deleteLink)="handleDeleteLink($event)"
    [questions]="updateQuestion.length > 0 ? updateQuestion : questions" (sendData)="handleCreateUpdate($event)"
    (fileUploadMessage)="handleFileUplodMessage($event)"></app-dynamic-form>
  <p-messages [(value)]="formMessages" [enableService]="false"></p-messages>
</p-dialog>

<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>

<app-footer></app-footer>